import React from 'react';
import block from 'bem-cn';
import Spinner from 'components/Spinner/view/desktop';

import FilterBlock from './FilterBlock';
import Table from './Table/Table';
import useCashModel from '../../../../../hooks/useCashModel';

import './Cash.scss';

const b = block('cash');

const Cash = ({ isMobile }) => {
  const model = useCashModel();

  return (
    <div className={b({ isMobile })}>
      <Spinner isLoading={model.actionProcessing} />

      <FilterBlock
        isMobile={isMobile}
        count={model.count}
        currentPage={model.page}
        onPageClick={model.setPage}
        isOnlyTotal={model.isOnlyTotal}
        setIsOnlyTotal={model.setIsOnlyTotal}
        date={model.date}
        activeDay={model.activeDay}
        onChangeBeginDate={model.onChangeBeginDate}
        onChangeEndDate={model.onChangeEndDate}
        onChangeActiveDay={model.onChangeActiveDay}
        isDirectOnly={model.isDirectOnly}
        setIsDirectOnly={model.setIsDirectOnly}
        isHigher={model.isHigher}
        setIsHigher={model.setIsHigher}
        isDeposit={model.isDeposit}
        setIsDeposit={model.setIsDeposit}
        isWithdrawal={model.isWithdrawal}
        setIsWithdrawal={model.setIsWithdrawal}
        isBonus={model.isBonus}
        setIsBonus={model.setIsBonus}
        filters={model.filters}
        setFilters={model.setFilters}
        handleSearchInChange={model.handleSearchInChange}
        filterValue={model.filterValue}
        handleSearchChange={model.handleSearchChange}
        searchResult={model.searchResult}
        isLoadingSearchResult={model.isLoadingSearchResult}
        handleResultClick={model.handleResultClick}
        onClickSearch={model.onClickSearch}
      />

      <Table
        currentPage={model.page}
        onPageClick={model.setPage}
        onItemsOnPageChanged={model.onItemsOnPageChanged}
        isMobile={isMobile}
        isOnlyTotal={model.isOnlyTotal}
        setIsOnlyTotal={model.setIsOnlyTotal}
      />
    </div>
  );
};

export default Cash;
